function getAnchor(url) {
  return (url.split('#').length > 1) ? document.URL.split('#')[1] : null;
}
document.addEventListener("DOMContentLoaded", function() {
  var urlAnchor = getAnchor(document.URL);
  if (urlAnchor) {
    window.scrollTo({
      top: document.getElementById(urlAnchor).offsetTop,
      behavior: "smooth"
    });
  }

  document.querySelectorAll('.navigation-artiste a').forEach((item) => {
    item.addEventListener('click', (event) => {
      var url = event.target.href;
      var urlParts = url.split('#');
      if(urlParts.length > 1) {
        var anchor = urlParts[1];
      }
      if(anchor) {
        event.preventDefault();
        window.scrollTo({
          top: document.getElementById(anchor).offsetTop,
          behavior: "smooth"
        });
      }
    });
  });

});